import React from 'react';

const BlackAndWhiteIcon = () => {
  return (
    <svg width="22px" height="21px" viewBox="0 0 22 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Image-Splitting" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Missing-Image-Match---Image-Edit-Tooltip" transform="translate(-409.000000, -1114.000000)" stroke="#262aff">
          <g id="Edit-Toolbar" transform="translate(283.000000, 1104.000000)">
            <g id="B&amp;W" transform="translate(137.000000, 20.000000) rotate(-270.000000) translate(-137.000000, -20.000000) translate(117.000000, 0.000000)">
              <g id="icon" transform="translate(20.500000, 20.000000) scale(1, -1) translate(-20.500000, -20.000000) translate(11.000000, 10.000000)">
                <circle id="Oval" fill="#262aff" cx="6.5" cy="6.5" r="7" />
                <circle id="Oval-Copy" fill="#FFFFFF" cx="12.5" cy="13.5" r="7" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BlackAndWhiteIcon;
